import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/protected/valuer/",  null, "/")

const getReports = (search) => http.post("/reports", search);
const getReport = (id) => http.get("/reports/" + id);
const putReport = (id, data) => http.put("/reports/" + id, data);
const getValuers = () => http.get("/valuers");
const getStatuses = () => http.get("/status");
const getManualValuerStatuses = () => http.get("/manual_status");
const changeValuer = (report_id, valuer_id) => http.post("/change/" + report_id + "/" + valuer_id);
const changeStatus = (report_id, status_id) => http.post("/manual_status/" + report_id + "/" + status_id);
const getPropertyModifications = (summary_id) => http.get("/property_modifications/" + summary_id);
const getReportPreview = (summary_id) => http.get("/report_preview/" + summary_id)
const getClients = () => http.get("/clients")
const getValuerCsv = (summary_id) => http.get("/csv/" + summary_id)

const getRicsNotifications = () => http.get("/rics_notifications")

const ValuerAmendPut = (summary_id, section, identifier, body) => http.put(`/amend/${summary_id}/${section}/${identifier}`, body)
const ValuerAmendGet = (summary_id, section) => http.get(`/amend/${summary_id}/${section}`)
const ValuerAmendFileGet = (summary_id, section, identifier) => http.get(`/amend_files/${summary_id}/${section}/${identifier}`)
const ValuerAmendFilePut = (summary_id, section, identifier, body) => http.put(`/amend_files/${summary_id}/${section}/${identifier}`, body)
const ValuationRequestedBeforeCheck = (summary_id) => http.get(`/previous_request/${summary_id}`)
const postManualPdfUpload = (summary_id, body) => http.post(`/manual_pdf_upload/${summary_id}`, body)
const getManualPdfUpload = (summary_id) => http.get(`/manual_pdf_upload/${summary_id}`)
const submitToClient = (summary_id) => http.post("/submit_to_client/" + summary_id)
const getValuerChatHistory = (summary_id) => http.get("/chat/" + summary_id)
const postValuerChatHistory = (summary_id, body) => http.post("/chat/" + summary_id, body)

const getYamlTemplateNames = () => http.get("/template-list")
const getYamlTemplate    = (id) => http.get(`/templates/${id}`)
const uploadYamlTemplate = (payload) => http.post("/templates", payload)

export default {
    getReports,
    getReport,
    putReport,
    getValuers,
    getStatuses,
    getManualValuerStatuses,
    changeValuer,
    changeStatus,
    getPropertyModifications,
    getReportPreview,
    getClients,
    getValuerCsv,
    getRicsNotifications,
    ValuerAmendPut,
    ValuerAmendGet,
    ValuerAmendFileGet,
    ValuerAmendFilePut,
    ValuationRequestedBeforeCheck,
    postManualPdfUpload,
    getManualPdfUpload,
    submitToClient,
    getValuerChatHistory,
    postValuerChatHistory,
    getYamlTemplate,
    uploadYamlTemplate,
    getYamlTemplateNames
}